import type { CountryInfo } from '../types/country-info';

const COUNTRY_FLAG_BASE = 'https://web-shop-assets.s3.eu-central-1.amazonaws.com/country-flags';

const countryFlagSvgUrl = (countryCode: string) => `${COUNTRY_FLAG_BASE}/${countryCode}.svg`;

const countryInfo = (code: string, name: string): CountryInfo => ({
  code,
  name,
  flagSvg: countryFlagSvgUrl(code),
});

export const DEFAULT_COUNTRY_INFO: CountryInfo = countryInfo('US', 'United States');

export const COUNTRY_INFO_MAP: Record<string, CountryInfo> = {
  AF: countryInfo('AF', 'Afghanistan'),
  AL: countryInfo('AL', 'Albania'),
  DZ: countryInfo('DZ', 'Algeria'),
  AD: countryInfo('AD', 'Andorra'),
  AO: countryInfo('AO', 'Angola'),
  AG: countryInfo('AG', 'Antigua and Barbuda'),
  AR: countryInfo('AR', 'Argentina'),
  AM: countryInfo('AM', 'Armenia'),
  AU: countryInfo('AU', 'Australia'),
  AT: countryInfo('AT', 'Austria'),
  AZ: countryInfo('AZ', 'Azerbaijan'),
  BS: countryInfo('BS', 'Bahamas'),
  BH: countryInfo('BH', 'Bahrain'),
  BD: countryInfo('BD', 'Bangladesh'),
  BB: countryInfo('BB', 'Barbados'),
  BY: countryInfo('BY', 'Belarus'),
  BE: countryInfo('BE', 'Belgium'),
  BZ: countryInfo('BZ', 'Belize'),
  BJ: countryInfo('BJ', 'Benin'),
  BT: countryInfo('BT', 'Bhutan'),
  BO: countryInfo('BO', 'Bolivia'),
  BA: countryInfo('BA', 'Bosnia and Herzegovina'),
  BW: countryInfo('BW', 'Botswana'),
  BR: countryInfo('BR', 'Brazil'),
  BN: countryInfo('BN', 'Brunei'),
  BG: countryInfo('BG', 'Bulgaria'),
  BF: countryInfo('BF', 'Burkina Faso'),
  BI: countryInfo('BI', 'Burundi'),
  CV: countryInfo('CV', 'Cape Verde'),
  KH: countryInfo('KH', 'Cambodia'),
  CM: countryInfo('CM', 'Cameroon'),
  CA: countryInfo('CA', 'Canada'),
  CF: countryInfo('CF', 'Central African Republic'),
  TD: countryInfo('TD', 'Chad'),
  CL: countryInfo('CL', 'Chile'),
  CN: countryInfo('CN', 'China'),
  CO: countryInfo('CO', 'Colombia'),
  KM: countryInfo('KM', 'Comoros'),
  CG: countryInfo('CG', 'Congo'),
  CD: countryInfo('CD', 'Congo (DRC)'),
  CR: countryInfo('CR', 'Costa Rica'),
  HR: countryInfo('HR', 'Croatia'),
  CU: countryInfo('CU', 'Cuba'),
  CY: countryInfo('CY', 'Cyprus'),
  CZ: countryInfo('CZ', 'Czech Republic'),
  DK: countryInfo('DK', 'Denmark'),
  DJ: countryInfo('DJ', 'Djibouti'),
  DM: countryInfo('DM', 'Dominica'),
  DO: countryInfo('DO', 'Dominican Republic'),
  EC: countryInfo('EC', 'Ecuador'),
  EG: countryInfo('EG', 'Egypt'),
  SV: countryInfo('SV', 'El Salvador'),
  GQ: countryInfo('GQ', 'Equatorial Guinea'),
  ER: countryInfo('ER', 'Eritrea'),
  EE: countryInfo('EE', 'Estonia'),
  SZ: countryInfo('SZ', 'Eswatini'),
  ET: countryInfo('ET', 'Ethiopia'),
  FJ: countryInfo('FJ', 'Fiji'),
  FI: countryInfo('FI', 'Finland'),
  FR: countryInfo('FR', 'France'),
  GA: countryInfo('GA', 'Gabon'),
  GM: countryInfo('GM', 'Gambia'),
  GE: countryInfo('GE', 'Georgia'),
  DE: countryInfo('DE', 'Germany'),
  GH: countryInfo('GH', 'Ghana'),
  GR: countryInfo('GR', 'Greece'),
  GD: countryInfo('GD', 'Grenada'),
  GT: countryInfo('GT', 'Guatemala'),
  GN: countryInfo('GN', 'Guinea'),
  GW: countryInfo('GW', 'Guinea-Bissau'),
  GY: countryInfo('GY', 'Guyana'),
  HT: countryInfo('HT', 'Haiti'),
  HN: countryInfo('HN', 'Honduras'),
  HK: countryInfo('HK', 'Hong Kong'),
  HU: countryInfo('HU', 'Hungary'),
  IS: countryInfo('IS', 'Iceland'),
  IN: countryInfo('IN', 'India'),
  ID: countryInfo('ID', 'Indonesia'),
  IR: countryInfo('IR', 'Iran'),
  IQ: countryInfo('IQ', 'Iraq'),
  IE: countryInfo('IE', 'Ireland'),
  IL: countryInfo('IL', 'Israel'),
  IT: countryInfo('IT', 'Italy'),
  CI: countryInfo('CI', 'Ivory Coast'),
  JM: countryInfo('JM', 'Jamaica'),
  JP: countryInfo('JP', 'Japan'),
  JO: countryInfo('JO', 'Jordan'),
  KZ: countryInfo('KZ', 'Kazakhstan'),
  KE: countryInfo('KE', 'Kenya'),
  KI: countryInfo('KI', 'Kiribati'),
  KW: countryInfo('KW', 'Kuwait'),
  KG: countryInfo('KG', 'Kyrgyzstan'),
  LA: countryInfo('LA', 'Laos'),
  LV: countryInfo('LV', 'Latvia'),
  LB: countryInfo('LB', 'Lebanon'),
  LS: countryInfo('LS', 'Lesotho'),
  LR: countryInfo('LR', 'Liberia'),
  LY: countryInfo('LY', 'Libya'),
  LI: countryInfo('LI', 'Liechtenstein'),
  LT: countryInfo('LT', 'Lithuania'),
  LU: countryInfo('LU', 'Luxembourg'),
  MO: countryInfo('MO', 'Macau'),
  MG: countryInfo('MG', 'Madagascar'),
  MW: countryInfo('MW', 'Malawi'),
  MY: countryInfo('MY', 'Malaysia'),
  MV: countryInfo('MV', 'Maldives'),
  ML: countryInfo('ML', 'Mali'),
  MT: countryInfo('MT', 'Malta'),
  MH: countryInfo('MH', 'Marshall Islands'),
  MR: countryInfo('MR', 'Mauritania'),
  MU: countryInfo('MU', 'Mauritius'),
  MX: countryInfo('MX', 'Mexico'),
  FM: countryInfo('FM', 'Micronesia'),
  MD: countryInfo('MD', 'Moldova'),
  MC: countryInfo('MC', 'Monaco'),
  MN: countryInfo('MN', 'Mongolia'),
  ME: countryInfo('ME', 'Montenegro'),
  MA: countryInfo('MA', 'Morocco'),
  MZ: countryInfo('MZ', 'Mozambique'),
  MM: countryInfo('MM', 'Myanmar'),
  NA: countryInfo('NA', 'Namibia'),
  NR: countryInfo('NR', 'Nauru'),
  NP: countryInfo('NP', 'Nepal'),
  NL: countryInfo('NL', 'Netherlands'),
  NZ: countryInfo('NZ', 'New Zealand'),
  NI: countryInfo('NI', 'Nicaragua'),
  NE: countryInfo('NE', 'Niger'),
  NG: countryInfo('NG', 'Nigeria'),
  MK: countryInfo('MK', 'North Macedonia'),
  NO: countryInfo('NO', 'Norway'),
  OM: countryInfo('OM', 'Oman'),
  PK: countryInfo('PK', 'Pakistan'),
  PW: countryInfo('PW', 'Palau'),
  PA: countryInfo('PA', 'Panama'),
  PG: countryInfo('PG', 'Papua New Guinea'),
  PY: countryInfo('PY', 'Paraguay'),
  PE: countryInfo('PE', 'Peru'),
  PH: countryInfo('PH', 'Philippines'),
  PL: countryInfo('PL', 'Poland'),
  PT: countryInfo('PT', 'Portugal'),
  QA: countryInfo('QA', 'Qatar'),
  RO: countryInfo('RO', 'Romania'),
  RU: countryInfo('RU', 'Russia'),
  RW: countryInfo('RW', 'Rwanda'),
  KN: countryInfo('KN', 'Saint Kitts and Nevis'),
  LC: countryInfo('LC', 'Saint Lucia'),
  VC: countryInfo('VC', 'Saint Vincent and the Grenadines'),
  WS: countryInfo('WS', 'Samoa'),
  SM: countryInfo('SM', 'San Marino'),
  ST: countryInfo('ST', 'São Tomé and Príncipe'),
  SA: countryInfo('SA', 'Saudi Arabia'),
  SN: countryInfo('SN', 'Senegal'),
  RS: countryInfo('RS', 'Serbia'),
  SC: countryInfo('SC', 'Seychelles'),
  SL: countryInfo('SL', 'Sierra Leone'),
  SG: countryInfo('SG', 'Singapore'),
  SK: countryInfo('SK', 'Slovakia'),
  SI: countryInfo('SI', 'Slovenia'),
  SB: countryInfo('SB', 'Solomon Islands'),
  SO: countryInfo('SO', 'Somalia'),
  ZA: countryInfo('ZA', 'South Africa'),
  SS: countryInfo('SS', 'South Sudan'),
  KR: countryInfo('KR', 'South Korea'),
  ES: countryInfo('ES', 'Spain'),
  LK: countryInfo('LK', 'Sri Lanka'),
  SD: countryInfo('SD', 'Sudan'),
  SR: countryInfo('SR', 'Suriname'),
  SE: countryInfo('SE', 'Sweden'),
  CH: countryInfo('CH', 'Switzerland'),
  SY: countryInfo('SY', 'Syria'),
  TW: countryInfo('TW', 'Taiwan'),
  TJ: countryInfo('TJ', 'Tajikistan'),
  TZ: countryInfo('TZ', 'Tanzania'),
  TH: countryInfo('TH', 'Thailand'),
  TL: countryInfo('TL', 'Timor-Leste'),
  TG: countryInfo('TG', 'Togo'),
  TO: countryInfo('TO', 'Tonga'),
  TT: countryInfo('TT', 'Trinidad and Tobago'),
  TN: countryInfo('TN', 'Tunisia'),
  TR: countryInfo('TR', 'Turkey'),
  TM: countryInfo('TM', 'Turkmenistan'),
  TV: countryInfo('TV', 'Tuvalu'),
  UG: countryInfo('UG', 'Uganda'),
  UA: countryInfo('UA', 'Ukraine'),
  AE: countryInfo('AE', 'United Arab Emirates'),
  GB: countryInfo('GB', 'United Kingdom'),
  US: DEFAULT_COUNTRY_INFO,
  UY: countryInfo('UY', 'Uruguay'),
  UZ: countryInfo('UZ', 'Uzbekistan'),
  VU: countryInfo('VU', 'Vanuatu'),
  VE: countryInfo('VE', 'Venezuela'),
  VN: countryInfo('VN', 'Vietnam'),
  YE: countryInfo('YE', 'Yemen'),
  ZM: countryInfo('ZM', 'Zambia'),
  ZW: countryInfo('ZW', 'Zimbabwe'),
};
